import * as yup from 'yup';

export default yup.object({
    name: yup.string().trim().required('Name is a required field'),
    withActor: yup.boolean(),
    integration_idn: yup.string().when('withActor', {
        is: true,
        then: (schema) => schema.required('Integration is a required field')
    }),
    connector_idn: yup.string().when('withActor', {
        is: true,
        then: (schema) => schema.required('Connector is a required field')
    }),
    external_id: yup.string().when('withActor', {
        is: true,
        then: (schema) => schema.required('External Id is a required field')
    })
});
